import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';
import DLink from '../../pieces/DLink';

export default function FirstTestCase() {

    return (
        <div>
            <DHeader>Run your First Test Case</DHeader>
       
            <DText>
            If you have cloned Laeyerz, you will find the QuickStart Example to build a simple workflow. This will be in the laeyerz/quickstart directory.
            
            </DText>
            <DText>
            Run the QuickStart Example by running the following command:
            </DText>

            
            <DCode>
                {`python QuickStart.py`}
            </DCode>

            <DText>
                You can also find the QuickStart along with more example cases in the laeyerz-examples github repository. <DLink to="https://github.com/pixagan/laeyerz-examples" target="_blank" rel="noopener noreferrer">https://github.com/pixagan/laeyerz-examples</DLink>
            </DText>
       
        </div>
    )
}